
import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import pack_normals from "../chunks/pack_normals.wgsl";
import pack_depth from "../chunks/pack_depth.wgsl";
import mat_inverse from "../chunks/mat-inverse.wgsl";
import { getEnvMapSampleChunk } from "../chunks/env_sample";
import tonemap from "../chunks/tonemap.wgsl";
import hatch from "../chunks/hatch_pattern.wgsl";
import crossHatch from "../chunks/cross_hatch.wgsl";
import { getObjectUniformsDeclaration } from "./uniforms/ObjectUniforms";
import { getMaterialUniformsDeclaration } from "./MaterialUniforms";
import heatmap from "../chunks/heatmap.wgsl";
import theming_and_highlighting from "../chunks/theming_and_highlighting.wgsl";
import uberShader from "./uber.wgsl";
import { getModelMatrixHook } from "./modelMatrixHook";
import { FrameBindGroup } from "./FrameBindGroup";
import { getVertexTransformChunk } from "../chunks/vertex_transform";
import wboitCode from "../chunks/wboit.wgsl";

export function getUberShader(
material,
hasUV,
hasTextures,
hasVertexColors,
isUVW,
isGamma,
isRGBM,
gammaInput,
hasInstanceIdMap,
useIrradianceMap,
useWboit,
categoryHighlightingEnabled = false,
categoryHighlightingFallback = false,
idOnly = false,
useUnorm16 = false,
customTexShaderChunk = '')
{
  // hasCategoryTarget: true when category highlighting uses a dedicated render target (not fallback mode)
  const hasCategoryTarget = categoryHighlightingEnabled && !categoryHighlightingFallback;
  const hasCustomTexture = customTexShaderChunk !== '';

  return $wgsl(uberShader, {
    frameBindGroup: FrameBindGroup.getDeclaration(0),
    objectUniforms: getObjectUniformsDeclaration(1, hasInstanceIdMap),
    modelMatrixHook: getModelMatrixHook(),
    materialUniforms: getMaterialUniformsDeclaration(2),
    pack_normals,
    pack_depth,
    mat_inverse,
    tonemap,
    envMapSample: getEnvMapSampleChunk(isGamma, isRGBM, gammaInput),
    hatch,
    crossHatch,
    heatmap,
    metalMaterial: material.metal,
    hasUV,
    hasTextures,
    hasVertexColors,
    isUVW,
    theming_and_highlighting,
    gammaInput,
    useIrradianceMap,
    vertexTransform: getVertexTransformChunk(),
    useWboit,
    wboitChunk: useWboit ? wboitCode : '',
    categoryHighlighting: categoryHighlightingEnabled,
    categoryHighlightingFallback,
    hasCategoryTarget,
    idOnly,
    useUnorm16,
    customTexShaderChunk,
    hasCustomTexture
  });
}